import { useRecoilValue } from "recoil";

import {
  isFilteredRowsSF,
  visiblePassengersBookingsSelector,
} from "@ryde/shared";

import { usePageContext } from "../contexts";
import { useBookingsNavigation } from "../navigation";

export const useResolveSearchFilteredRows = (): {
  isHasFilteredResult: boolean;
} => {
  const { entity } = usePageContext();
  const passengers = useRecoilValue(visiblePassengersBookingsSelector);
  const { isCalendarBookingView } = useBookingsNavigation();
  const isHasFilteredRows = useRecoilValue(isFilteredRowsSF(entity));
  let isHasFilteredResult;

  switch (true) {
    case isCalendarBookingView:
      isHasFilteredResult = passengers.length > 0;
      break;
    default:
      isHasFilteredResult = isHasFilteredRows;
      break;
  }

  return { isHasFilteredResult };
};
